export default __webpack_public_path__ + "static/media/right-arrow.52f16e31.svg";